import { render } from "./pagination.vue?vue&type=template&id=036c4331"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/components/pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "036c4331"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('036c4331', __exports__)) {
    console.log('reload')
    api.reload('036c4331', __exports__)
  }
  
  module.hot.accept("./pagination.vue?vue&type=template&id=036c4331", () => {
    console.log('re-render')
    api.rerender('036c4331', render)
  })

}


export default __exports__